import React from "react";
import clsx from "clsx";

export default function ProductListHeader({breadcrumbs, showFilter, _onFilterClick}) {
    return <div className="card-header flex-nowrap py-2">
        <h3 className="card-title align-items-start flex-column">
            <ul className="breadcrumb breadcrumb-dot fw-semibold text-gray-600 fs-7 my-1">
                {
                    breadcrumbs.type != undefined ?
                        [
                            <li
                                key={1}
                                className={
                                    clsx('breadcrumb-item',
                                        {'text-gray-600 fw-bold': breadcrumbs.category == undefined},
                                        {'text-gray-500': breadcrumbs.category != undefined},
                                    )
                                }
                            >{breadcrumbs.type[0].name}</li>,
                            breadcrumbs.category && <li
                                key={2}
                                className={
                                    clsx('breadcrumb-item',
                                        {'text-gray-600 fw-bold': breadcrumbs.collection == undefined},
                                        {'text-gray-500': breadcrumbs.collection != undefined},
                                    )
                                }
                            >{breadcrumbs.category[0].name}</li>,
                            breadcrumbs.collection && <li
                                key={3}
                                className={
                                    clsx('breadcrumb-item text-gray-600 fw-bold'
                                    )
                                }
                            >{breadcrumbs.collection[0].name}</li>,
                        ]
                        :
                        <li className="breadcrumb-item text-gray-600 fw-bold">All Products</li>
                }
                {
                    breadcrumbs.brand && <li
                        className={
                            clsx('breadcrumb-item',
                            )
                        }
                    >({breadcrumbs.brand[0].name})</li>
                }
            </ul>
        </h3>
        <div className="card-toolbar">
            <div>
                <a
                    href="#"
                    className={
                        clsx('btn btn-sm btn-flex fw-bold',
                        {'btn-light': !showFilter},
                        {'btn-primary': showFilter},
                        )
                    }
                    onClick={(e) => {_onFilterClick(e);}}
                >
                    <i className="ki-duotone ki-filter fs-5 me-1">
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                    Filter
                </a>
            </div>
        </div>
    </div>
}